import { Card ,Tabs } from 'antd'
import React from 'react'
import CustomerSetting from '../Component/Valuedcustomersetting';
export default function CustomerPageSetting() {
    const { TabPane } = Tabs;

    function callback(key) {
        // console.log(key);
      }
  return (
    <div>
        <Card>
        <CustomerSetting/>
        </Card>
    </div>
  )
}
